<template>
  <div class="company_card">
    <div class="company_info">
      <div class="company_nameAndDesc">
        <div class="company_name">
          <span>{{ coInfo.companyName }}</span>
        </div>
        <div class="company_desc">
          <div class="company_tag" v-if="coInfo.isModelEmployer">
            <!-- 优选雇主 -->
            <img src="@/assets/img/activity/employer_icon@2x.png" alt="" />
          </div>
          <span>{{ coInfo.companyTypeString }}</span>
          <span v-if="coInfo.companySizeString"
            >&nbsp;|&nbsp;{{ coInfo.companySizeString }}</span
          >
        </div>
      </div>
      <div class="company_logo">
        <img :src="coInfo.companyLogo" alt="" />
      </div>
    </div>
    <div class="company_recommended_reason" v-if="getRecommendTip(coInfo)">
      <div class="icon_info">
        <img src="@/assets/img/activity/icon_hand@2x.png" alt="" />
        <span>推荐理由：</span>
      </div>
      <div class="recommended_reason_info">
        {{ getRecommendTip(coInfo) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CompanyCard",
  props: {
    coInfo: {
      type: Object,
      default: () => {},
    },
    jobSource: {
      type: String,
      default: "1",
    },
  },
  methods: {
    getRecommendTip(item) {
      //职位来源：1-文件导入 2-搜推职位搜索
      const { sesameLabelList, recommendTip } = item;
      const sesameLabelListData = sesameLabelList || [];
      const sesameLabel = sesameLabelListData
        .map(({ labelName }) => labelName)
        .filter((i) => i)
        .join(",");
      if (this.jobSource == "1") {
        return recommendTip || sesameLabel || "";
      }
      return sesameLabel || "";
    },
  },
};
</script>
<style scoped lang="less">
.company_card {
  background: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  border: 2px solid #ffffff;
  padding: 24px 16px;
  margin: 8px;
  margin-bottom: 0;
  .company_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .company_nameAndDesc {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 46px;
      .company_name {
        font-weight: 600;
        font-size: 18px;
        color: #222222;
        display: flex;
        align-items: center;
        line-height: 18px;
        & > img {
          width: auto;
          height: 11px;
          margin-left: 6px;
          margin-top: 2px;
        }
        & > span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .company_desc {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        color: #7c8087;
        line-height: 14px;
        .company_tag {
          display: flex;
          align-items: center;
          margin-right: 10px;
          & > img {
            width: 52px;
            height: auto;
          }
        }
        & > span {
          &:last-child {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .company_logo {
      width: 48px;
      height: 48px;
      border-radius: 4px;
      border: 1px solid #d8d8d8;
      margin-left: 29px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: auto;
        border-radius: 4px;
      }
    }
  }
  .company_recommended_reason {
    margin-top: 8px;
    font-weight: 400;
    font-size: 12px;
    color: #7c7f87;
    display: flex;
    align-items: center;
    .icon_info {
      font-size: 12px;
      color: #ff6c0e;
      font-weight: 600;
      display: flex;
      align-items: center;
      & > img {
        width: 13px;
        height: auto;
        margin-right: 2px;
      }
    }
    .recommended_reason_info {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
